import { CANONICAL_HOSTNAME, LEGACY_HOSTNAME } from '~/config'

const acceptableHosts = new Set([
  CANONICAL_HOSTNAME,
  `www.${CANONICAL_HOSTNAME}`,
  `docs.${CANONICAL_HOSTNAME}`,
  LEGACY_HOSTNAME,
  `www.${LEGACY_HOSTNAME}`,
  `docs.${LEGACY_HOSTNAME}`,
])

export const isCanonicalLink = (link: string): boolean => {
  /**
   * Check if the link is a canonical link (or a relative link)
   */
  const url = new URL(link, `https://${CANONICAL_HOSTNAME}`)
  if (acceptableHosts.has(url.hostname)) return true
  return false
}
